import axios from "axios"
	//文艺职务数据
	export function getJobList(params){
        return axios.get('/get_job_list', { params: params })
            .then((response) => response)
            .catch((error) => {
            console.log(error);
        });
    }
	